export const getOnboardingPath = (userProfile) =>
  userProfile?.isIndividual
    ? "/personal-account-onboarding"
    : "/business-account-onboarding";
